import { rem } from "polished";
import styled, { css } from "styled-components";

import type { ImagePosition } from "@/components/editor/image-positioner/image-positioner-component";
import type { ImageFit } from "@/components/editor/shared/header/header-settings-component";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const LogoWrapper = withViewportStyle("div")`
  height: 100%;
  display: flex;
  align-items: center;

  ${(props) => props.$viewport.tablet`
    justify-content: center;
  `}
`;

export const Logo = withViewportStyle("img")<{
  isLogoResized: boolean;
}>`
  max-height: ${({ isLogoResized }) => (isLogoResized ? rem(100) : rem(40))};
  max-width: 100%;
  object-fit: contain;

  ${(props) => props.$viewport.mobile`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(80) : rem(40))};
  `}
`;

export const BackgroundImage = styled.div<{
  $backgroundImage?: string;
  backgroundPosition: ImagePosition;
  imageFit?: ImageFit;
}>`
  ${({ $backgroundImage, imageFit }) =>
    $backgroundImage &&
    css`
      background-image: url(${$backgroundImage});
      background-size: ${imageFit || "cover"};
      background-repeat: no-repeat;
      background-position: center;
    `}
  ${(props) =>
    props.backgroundPosition &&
    css`
      background-position: ${props.backgroundPosition};
    `}
`;

export const ContentWrapper = withViewportStyle("div")`
  padding: ${rem(66)} ${rem(108)};
  display: grid;
  grid-row-gap: ${rem(32)};

  .ck-content h1,
  .ck-content h2,
  .ck-content h3,
  .ck-content h4,
  .ck-content h5,
  .ck-content p,
  .ck-content li {
    margin: 0;
  }

  ${(props) => props.$viewport.tablet`
    grid-row-gap: ${rem(24)};

    .text-primitive,
    .ck-content h1,
    .ck-content h2,
    .ck-content h3,
    .ck-content h4,
    .ck-content h5,
    .ck-content p,
    .ck-content li {
      text-align: center;
    }
  `}

  ${(props) => props.$viewport.mobile`
    padding: ${rem(16)};
  `}
`;
